import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PharmaciesRoutingModule } from './pharmacies-routing.module';
import { PharmaciesComponent } from './pharmacies.component';
import { BzAptekaModule, BzCountPackagingModule, BzFAQModule, ReturnBtnArrowModule } from '../../modules-ui';
import { SharedModule } from '@shared';
import { TranslocoModule } from '@ngneat/transloco';
import { BzSelectRegionModule } from 'src/app/modules-ui/action-elements/bz-select-city-popup/bz-select-city-popup.module';
import { BzSpinnerModule } from '../../modules-ui/blocks-ui/bz-spinner/spinner.module';
import { StaticFooterModule } from 'src/app/modules-ui/layouts';
import { BzPricesTableModule } from 'src/app/modules-ui/blocks-ui/bz-prices-table/bz-prices-table.module';


@NgModule({
  declarations: [PharmaciesComponent],
  imports: [
    CommonModule,
    PharmaciesRoutingModule,
    TranslocoModule,
    BzSelectRegionModule,
    BzAptekaModule,
    BzCountPackagingModule,
    StaticFooterModule,
    SharedModule,
    ReturnBtnArrowModule,
    BzSpinnerModule,
    BzFAQModule,
    BzPricesTableModule
  ]
})
export class PharmaciesModule { }
